import { initialsOf } from "@/lib/format";
import { cn } from "@/lib/cn";

const SIZES = {
  sm: "h-7 w-7 text-[11px]",
  md: "h-9 w-9 text-xs",
  lg: "h-12 w-12 text-sm",
} as const;

/**
 * Initials only. There is no avatar upload anywhere in the backend, so showing
 * a photo placeholder would imply a feature that does not exist.
 */
export function Avatar({
  name,
  size = "md",
  className,
}: {
  name: string | null | undefined;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-accent-wash font-mono font-medium uppercase text-accent",
        SIZES[size],
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
